module.exports = __webpack_public_path__ + "img/Banner_02_Arreglalo_Febrero_mobile.7b310eb2.jpg";